export const RESOLVED = "Resolved";
export const UNRESOLVED = "Unresolved";
export const TICKETS_TAG = "TICKETS_TAG";
export const NOTE_CREATED_SUCCESSFULLY = "Note created successfully";
export const NOTE_UPDATED_SUCCESSFULLY = "Note updated successfully";
export const NOTE_DELETED_SUCCSSFULLY = "Note deleted successfully";

export const TICKET_DETAIlS_TAB = "details";
export const TICKET_CHAT_TAB = "conversation";

export const TICKET_TYPE_PRICED = "PRICED";
export const TICKET_TYPE_UNPRICED = "UNPRICED";
export const TICKET_TYPE_CHAT = "CHAT";
export const TICKET_TYPE_NONCHAT = "NONCHAT";

export const TICKET_TYPES = [
  {
    value: TICKET_TYPE_PRICED,
    label: "Priced",
  },
  {
    value: TICKET_TYPE_UNPRICED,
    label: "Unpriced",
  },
  {
    value: TICKET_TYPE_CHAT,
    label: "Chat",
  },
  {
    value: TICKET_TYPE_NONCHAT,
    label: "Non chat",
  },
];

export const TICKET_SORT_OPTIONS = {
  TICKET_TYPE_NEAREST_ETD_SORT: {
    value: "NEAREST",
    label: "Nearest first",
    group: "Sort by ETD",
  },
  TICKET_TYPE_FARTHEST_ETD_SORT: {
    value: "FARTHEST",
    label: "Farthest first",
    group: "Sort by ETD",
  },
  TICKET_TYPE_LATEST_SORT: {
    value: "LATEST",
    label: "Latest first",
    group: "Sort by Creation date",
  },
  TICKET_TYPE_OLDEST_SORT: {
    value: "OLDEST",
    label: "Oldest first",
    group: "Sort by Creation date",
  },
  TICKET_TYPE_RESOLVED_LATEST_SORT: {
    value: "RESOLVED_LATEST",
    label: "Latest first",
    group: "Sort by Resolved date",
  },
  TICKET_TYPE_RESOLVED_OLDEST_SORT: {
    value: "RESOLVED_OLDEST",
    label: "Oldest first",
    group: "Sort by Resolved date",
  },
};

export const PAYMENT_PAID = "Paid";

export const TICKET_PAYMENT = "TICKET_PAYMENT";
export const TICKET_UPDATED = "TICKET_UPDATED";
export const TICKET_CREATED = "TICKET_CREATED";
export const TICKET_RESOLVED = "TICKET_RESOLVED";
export const TICKET_PAID = "TICKET_PAID";

export const TICKET_ETD_UNSET = "TICKET_ETD_UNSET";
export const TICKET_ETD_TODAY_OR_PASSED = "TICKET_ETD_TODAY_OR_PASSED";
export const TICKET_ETD_APPROACHING = "TICKET_ETD_APPROACHING";

export const TICKET_ETD_START_DATE = "etd_start_date";
export const TICKET_ETD_END_DATE = "etd_end_date";
export const TICKET_ETD_SELECT_PERIOD = "etd_select_period";

export const TICKET_CREATE_START_DATE = "create_start_date";
export const TICKET_CREATE_END_DATE = "create_end_date";
export const TICKET_CREATE_SELECT_PERIOD = "create_select_period";

export const TICKET_RESOLVED_START_DATE = "resolved_start_date";
export const TICKET_RESOLVED_END_DATE = "resolved_end_date";
export const TICKET_RESOLVED_SELECT_PERIOD = "resolved_select_period";

export const TICKET_PRIORITY_TYPES = {
  CRITICAL: "CRITICAL",
  HIGH: "HIGH",
  MEDIUM: "MEDIUM",
  LOW: "LOW",
} as const;

export type TICKET_PRIORITY_TYPES_TYPE = keyof typeof TICKET_PRIORITY_TYPES;

export const TICKET_PRIORITY_TYPES_DISPLAY = {
  [TICKET_PRIORITY_TYPES.CRITICAL]: "Critical",
  [TICKET_PRIORITY_TYPES.HIGH]: "High",
  [TICKET_PRIORITY_TYPES.MEDIUM]: "Medium",
  [TICKET_PRIORITY_TYPES.LOW]: "Low",
};

export const TICKET_PRIORITY_OPTIONS = [
  {
    value: TICKET_PRIORITY_TYPES.CRITICAL,
    label: TICKET_PRIORITY_TYPES_DISPLAY.CRITICAL,
  },
  {
    value: TICKET_PRIORITY_TYPES.HIGH,
    label: TICKET_PRIORITY_TYPES_DISPLAY.HIGH,
  },
  {
    value: TICKET_PRIORITY_TYPES.MEDIUM,
    label: TICKET_PRIORITY_TYPES_DISPLAY.MEDIUM,
  },
  {
    value: TICKET_PRIORITY_TYPES.LOW,
    label: TICKET_PRIORITY_TYPES_DISPLAY.LOW,
  },
];

export const REMINDER_OPTIONS = {
  HOURS_24: "1",
  DAYS_3: "3",
  WEEK_1: "7",
  DAYS_15: "15",
  CUSTOM: "CUSTOM",
};

export const REMINDER_OPTIONS_LIST = [
  { value: REMINDER_OPTIONS.HOURS_24, label: "24 hrs" },
  { value: REMINDER_OPTIONS.DAYS_3, label: "3 days" },
  { value: REMINDER_OPTIONS.WEEK_1, label: "1 week" },
  { value: REMINDER_OPTIONS.DAYS_15, label: "15 days" },
  { value: REMINDER_OPTIONS.CUSTOM, label: "Custom" },
];
